import type { Technology } from 'domain/shared/career';
import type { PositionType } from 'domain/shared/employee';
import type { PositionProfile } from '../../types';
import { createPositionProfileLabelsResolver } from '../../shared/utils/positionProfileLabels';
import type { PositionProfileLabels } from '../../shared/utils/positionProfileLabels';

export type PositionProfileDetailsViewModel = PositionProfile & PositionProfileLabels;

export const mapPositionProfileDetails = (
  profile: PositionProfile,
  positions: PositionType[],
  technologies: Technology[],
): PositionProfileDetailsViewModel => {
  const resolveLabels = createPositionProfileLabelsResolver(positions, technologies);

  return {
    ...profile,
    ...resolveLabels(profile),
  };
};
